import Swiper from 'swiper/bundle';

export default function initializeAllCollapsesFile() {
    document.querySelectorAll('.block-icon-boxes').forEach(function(block) {
        new BlockIconBoxes(block);
    });
}

class BlockIconBoxes {
    constructor(block) {
        this.block = block;
        this.init();
    }

    init() {
        const slider = this.block.querySelector('.block-icon-boxes__slider:not(.block-icon-boxes__slider--disabled)');
        const swiper = new Swiper(slider, {
            speed: 1000,
            loop: true,
            spaceBetween: 24,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            navigation: {
                nextEl: this.block.querySelector('.slider__arrow--next'),
                prevEl: this.block.querySelector('.slider__arrow--prev'),
            },
            pagination: {
                el: '.slider__pagination',
                clickable: true,
            },
            breakpoints: {
                1200: {
                    slidesPerView: 4,
                },
                768: {
                    slidesPerView: 2,
                },
                0: {
                    slidesPerView: 1,
                },
            },
        });
    }
}
